const THOUSAND_MULTIPLIER = 'k';
const MILLION_MULTIPLIER = 'm';

export const extractNumber = (value) => {
  if (value === '') {
    return null;
  }
  return applyMultipliers(trimCommasFromNum(value));
};

export const trimCommasFromNum = value => value.replace(/,/g, '');

export const applyMultipliers = (value) => {
  const lowerCaseValue = value.toLowerCase();
  const indexOfThousand = lowerCaseValue.indexOf(THOUSAND_MULTIPLIER);
  const indexOfMillion = lowerCaseValue.indexOf(MILLION_MULTIPLIER);

  if (value.length < 2) {
    return Number(value);
  }

  if (indexOfThousand === value.length - 1) {
    return Number(value.slice(0, indexOfThousand)) * 1000;
  }

  if (indexOfMillion === value.length - 1) {
    return Number(value.slice(0, indexOfMillion)) * 1000000;
  }

  return Number(value);
};

export const addCommasToNum = (value, numberOfDecimalPlaces) => {
  if (isNaN(value) || value === null) {
    return '';
  }

  const options = {
    maximumFractionDigits: numberOfDecimalPlaces || 3
  };
  return Number(value).toLocaleString('en-GB', options);
};




// WEBPACK FOOTER //
// ./src/utility/fieldFormatters.js